import { shopLoyaltyPlaceHolderData } from '~/utils/placeholderData'

export default (shopUid) => {
    return useFetchWithTanstackQuery({
        queryKey: ['shopLoyalty', shopUid],
        queryFn: () => $fetch(`/api/center/shops/${shopUid}/loyaltyProgram`),
        options: {
            placeholderData: shopLoyaltyPlaceHolderData,
            staleTime: 5 * 60 * 1000 // 5 min
        }
    })
}
